import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/styles/index.scss";
import "@/styles/animate.scss";
import { MotionPlugin } from "@vueuse/motion";
import "@/assets/css/fonts.css";

createApp(App)
  .use(store)
  .use(MotionPlugin)
  .use(router)
  .use(ElementPlus)
  .mount("#app");
